const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import VotingNavigation from './contestants/VotingNavigation.jsx';
import Submitform from './contestants/Submitform.jsx';
import Logincontest from './Logincontest.jsx';

//Action to save and fetch data
import { fetchFrontSetting, frontsingleimmute, insertPayment, updateFrontData, stripePayment, couponApply, frontimmute, Userlogout } from '../actions/front_actions';

//Import Designs
import { Container, Backdrop, CircularProgress } from '@mui/material';

class Addcontest extends Component {

    constructor(props) {
        super(props);
        this.state = { language: "en", listgrid: "grid", wait: 0, form_val: null, short: this.props.shortagrument, all_cat_selected: null, checklimit: 0, currentcat: "" };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 })
        this.props.fetchFrontSetting(this.props.SITE_URL);
        if (typeof this.props.shortagrument !== "undefined") {
            this.setState({ listgrid: this.props.shortagrument.view });
        }
        this.setState({ wait: 0 })
    }

    handleGrid = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view });
        this.setState({ wait: 0 })
    }


    handleform = (form) => {
        this.setState({ wait: 1 })
        if (this.state.form_val == 'submit_form') {
            this.setState({ form_val: '' });
        } else {
            this.setState({ form_val: form });
        }
        this.setState({ wait: 0 })
    }

    handleCategoryChange = externalId => (event) => {
        let val = event.target.value;
        if (val != null) {
            this.props.fetchFrontSetting(this.props.SITE_URL, val).then(
                val => {
                    this.setState({ currentcat: val.selcategoryoptions });
                    const type = Array.isArray(this.props.model.taxonomy) && this.props.model.taxonomy.find(el => el.term_id == event.target.value);
                    if (type != null) {
                        const entrycount = val.entrycount;
                        const vote_contest_entry_person = type.vote_contest_entry_person;
                        if (entrycount !== null && vote_contest_entry_person !== null) {
                            if (parseInt(entrycount) >= parseInt(vote_contest_entry_person)) {
                                this.setState({ checklimit: event.target.value });
                            }
                            else {
                                this.setState({ checklimit: 0 })
                            }
                        }
                        else {
                            this.setState({ checklimit: 0 })
                        }
                    }
                }
            );
            this.setState({ all_cat_selected: event.target.value });
        }
    }

    //Immutable functions
    handleValueChange = externalId => (event) => {
        this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
    }

    handleFileChange = externalId => (event) => {
        let file = event.target.files[0];
        this.props.frontsingleimmute(externalId, event.target.name, file);
    }

    handleValueDate = externalId => (event) => {
        const find_editor = externalId.split('--');
        const arlength = find_editor.length;
        if (arlength >= 1) {
            const value = event;
            this.props.frontsingleimmute(find_editor[0], find_editor[1], value);
        }
    }

    handleValueCheckbox = externalId => (event, isChecked) => {
        let name = event.target.name;
        let get_previous_val = this.props.model.contestant_form[name];
        if (isChecked) {
            if (get_previous_val == '') {
                this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
            } else {
                let add_val = get_previous_val + "," + event.target.value;
                this.props.frontsingleimmute(externalId, event.target.name, add_val);
            }
        } else {
            if (get_previous_val != '') {
                let new_string = get_previous_val.replace(',' + event.target.value, '');
                let new_string_val = new_string.replace(event.target.value + ',', '');
                let new_string_vl = new_string_val.replace(event.target.value, '');
                this.props.frontsingleimmute(externalId, event.target.name, new_string_vl);
            }
        }
    }

    handleValueEditor = externalId => (event) => {
        let editor_val = (event.srcElement === undefined) ? event : event.srcElement.innerHTML;
        this.props.frontsingleimmute('contestant_form', externalId, editor_val);
    }

    paymentChange = (argument, payment_entry_open) => {
        this.props.updateFrontData(argument, payment_entry_open);
    }

    insertPayment = (gateway, details, amount, currency = '') => {
        this.props.insertPayment(this.props.SITE_URL, gateway, details, amount, currency);
    }

    stripePayment = (amount) => {
        this.props.stripePayment(this.props.SITE_URL, amount);
    }

    couponApply = (gateway, coupon, term_id) => {
        return this.props.couponApply(this.props.SITE_URL, gateway, coupon, term_id);
    }

    handleDrawer = (val) => {
        this.props.frontimmute('drawer', val);
    }

    render() {
        const { t } = this.props;
        const shortatts = this.props.shortagrument;
        const onlyloggedsubmit = shortatts.onlyloggedsubmit;
        const check_logged = shortatts.user_logged;

        const values = (typeof this.props.model !== "undefined") ? this.props.model : null;
        if ((values != null) && (this.state.wait != 1)) {

            let color = this.props.model.settings.color;
            let current_date = new Date(values.current_date);
            let submitentry;
            if (this.state.form_val == 'submit_form' || (shortatts.openform == 'on')) {
                submitentry = 1;
            } else {
                submitentry = 0;
            }

            let show_contestants = shortatts.showcontestants;
            let onlylogged_submit_state = (onlyloggedsubmit == 1 && check_logged == false && shortatts.openform == 'on') ? 1 : 0;
            return (
                <Container className="wpvc_showcontestant_container">
                    {this.props.shortagrument.navbar == 1 &&
                        <VotingNavigation
                            {...values}
                            {...color}
                            short={shortatts}
                            handleDrawer={this.handleDrawer}
                            handlelogout={() => this.props.Userlogout(this.props.SITE_URL)}
                            SITE_URL={this.props.SITE_URL}
                            handleview={this.handleGrid}
                            handleform={this.handleform}
                            view={this.state.listgrid}
                            hide_grid={show_contestants}
                            show_all_rules={0}
                        />
                    }

                    {
                        onlylogged_submit_state == 1 &&
                        <div className="wpvc_not_loggedin">
                            <Logincontest {...values} short={shortatts} SITE_URL={this.props.SITE_URL} CONSTANT={this.props.CONSTANT}
                                ORIGINAL_URL={this.props.ORIGINAL_URL} />
                        </div>
                    }

                    {submitentry == 1 && onlylogged_submit_state == 0 &&
                        <Submitform
                            {...values}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            ORIGINAL_URL={this.props.ORIGINAL_URL}
                            selcategory={this.state.all_cat_selected}
                            currentcat={this.state.currentcat}
                            catchange={this.handleCategoryChange}
                            valchange={this.handleValueChange}
                            filechange={this.handleFileChange}
                            ediorchange={this.handleValueEditor}
                            checkboxchange={this.handleValueCheckbox}
                            datepickerchange={this.handleValueDate}
                            paymentchange={this.paymentChange}
                            insertPayment={this.insertPayment}
                            stripePayment={this.stripePayment}
                            couponApply={this.couponApply}
                            checklimit={this.state.checklimit}
                            currentdate={current_date}
                        />
                    }
                </Container>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { frontsingleimmute, fetchFrontSetting, updateFrontData, insertPayment, stripePayment, couponApply, frontimmute, Userlogout })(withTranslation("translations")(Addcontest));